<template>
    <div>
        {{timeLeft}}
    </div>
</template>

<script>
import config from '../../../config'

const mainUrl = config.mainUrl
export default {
  name: 'CountDown',
  props: {
    minutes: {
      required: true
    },
    startSound: {},
    endSound: {},
    isPlayStart: {},
    isPlayEnd: {},
    real: {},

    data: {
      type: Object
    }
  },
  data () {
    return {
      totalSecond: 0,
      displayMinute: 0,
      displaySecond: 0,
      intervalTimer: null,
      timeLeft: '',
      endClock: true,
      sound: null
    }
  },
  created () {
    if (Number(this.minutes)) {
      this.totalSecond = Math.round(this.minutes * 60)
      if (this.startSound !== 'mute' && this.isPlayStart && (this.real === this.minutes || this.real === undefined)) {
        this.playSound(this.startSound, 'start')
      }

      this.intervalTimer = setInterval(() => {
        let secondsLeft = this.totalSecond
        if (secondsLeft < 0) {
          this.$emit('endCountDown', this.data)
          this.endClock = false
          clearInterval(this.intervalTimer)
          return
        }
        this.displayTimeLeft(secondsLeft)
        this.totalSecond--
        this.$emit('updateTimeCountDown', this.totalSecond)
      }, 1000)
    }
  },
  computed: {},
  watch: {},
  destroyed () {
    clearInterval(this.intervalTimer)
    if (this.sound) {
      this.sound.stop()
    }
  },
  methods: {
    playSound (link, type) {
      //      link = mainUrl + '/sound/' + link
      link = '/sound/' + link
      let vm = this
      if (type === 'start') {
        vm.$emit('updatePlayStart', false)
      }
      if (type === 'end') {
        vm.$emit('updatePlayEnd', false)
      }
      this.sound = new Howl({
        src: [link],
        volume: 0.5,
        onplay: function () {
          console.log('start PLAYCOUNTDOWN')
        },
        onend: function () {
          if (type === 'start') {
            vm.$emit('updatePlayStart', true)
          }
          if (type === 'end') {
            vm.$emit('updatePlayEnd', true)
          }
        }
      })
      this.sound.play()
    },
    zeroPadded (num) {
      // 4 --> 04
      return num < 10 ? `0${num}` : num
    },
    displayTimeLeft (secondsLeft) {
      const minutes = Math.floor(secondsLeft / 60)
      const seconds = secondsLeft % 60
      this.timeLeft = `${this.zeroPadded(minutes)}:${this.zeroPadded(seconds)}`
    }
  }
}
</script>
<style>

</style>
